import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import './App.css';
import TopBar from './components/TopBar';
import Header from './components/Header';
import Nav from './components/Nav';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import AdmissionsPage from './pages/AdmissionsPage';
import AcademicsPage from './pages/AcademicsPage';
import FacilitiesPage from './pages/FacilitiesPage';
import GalleryPage from './pages/GalleryPage';
import NewsPage from './pages/NewsPage';
import ContactPage from './pages/ContactPage';
import ManagementProvider from './management/ManagementProvider';
import { managementRoutes } from './management/routes';

const publicRoutes = {
  '/': 'home',
  '/about': 'about',
  '/admissions': 'admissions',
  '/academics': 'academics',
  '/facilities': 'facilities',
  '/gallery': 'gallery',
  '/news': 'news',
  '/contact': 'contact',
};

const pagePaths = Object.fromEntries(
  Object.entries(publicRoutes).map(([path, page]) => [page, path])
);

function PublicPage({ page }) {
  const navigate = useNavigate();

  const nav = (nextPage) => {
    navigate(pagePaths[nextPage] || '/');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      <TopBar onNav={nav} />
      <Header onNav={nav} />
      <Nav current={page} onNav={nav} />
      <main>
        {page === 'home' && <HomePage onNav={nav} />}
        {page === 'about' && <AboutPage />}
        {page === 'admissions' && <AdmissionsPage onNav={nav} />}
        {page === 'academics' && <AcademicsPage />}
        {page === 'facilities' && <FacilitiesPage />}
        {page === 'gallery' && <GalleryPage />}
        {page === 'news' && <NewsPage />}
        {page === 'contact' && <ContactPage />}
      </main>
      <Footer onNav={nav} />
    </>
  );
}

function App() {
  return (
    <ManagementProvider>
      <Router>
        <Routes>
          {Object.entries(publicRoutes).map(([path, page]) => (
            <Route key={path} path={path} element={<PublicPage page={page} />} />
          ))}

          {managementRoutes.map((route) => (
            <Route key={route.path} path={route.path} element={route.element} />
          ))}

          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Router>
    </ManagementProvider>
  );
}

export default App;
